
(function ($, d, ns) {
    ns.initToggleActiveSection = function () {
        $('.js-toggle-section').on('click', function (e) {
            e.preventDefault();
            var associatedControl = $(this).attr('data-toggle-section');
            //Parent - finds nearest parent...
            var toggleMode = $(this).attr('data-toggle-mode');
            if (toggleMode == 'parent') {
                $(this).closest('.' + associatedControl).toggleClass('active');
            } else {
                $('.' + associatedControl).toggleClass('active');
            }
            
        });
    };

    $(d).ready(function () {
        ns.initToggleActiveSection();
    });


})(jQuery, document, Crafted.Utilities);